<h1 mat-dialog-title>{{title}}</h1>

<mat-dialog-content>
  <p *ngIf="messageHtml; else plainMessage" [innerHTML]="messageHtml"></p>
  <ng-template #plainMessage>
    <p>{{message}}</p>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button type="button" class="btn-primary btn-md"  (click)="onConfirm()">Yes</button>
  <button  mat-button class="btn-default btn-md" (click)="onDismiss()">No</button>
</mat-dialog-actions>